import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { DatasourceService, AuthService } from '@app/core/services';
import { Observable } from 'rxjs/Rx';
import { IntlService } from '@progress/kendo-angular-intl';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid'; 
import { State } from '@progress/kendo-data-query'; 
import { User } from '@app/core/models';


@Component({
  selector: 'base-list',
  template: `OVERRIDES`,
  styleUrls: [], //OVERRIDES
  providers:  [ DatasourceService ]
})
export class BaseListComponent implements OnInit {

  @ViewChild(GridComponent, {static: false}) grid !: GridComponent;

  protected table: string = 'TABLE';
  
  protected state: State;  

  protected view: Observable<GridDataResult>;

  @Output() resultChange: EventEmitter<{name: string, result:any, sum:number}> = new EventEmitter();

  //Variables

  public currentUser: User;

  
  constructor(protected authService: AuthService, protected service: DatasourceService, protected intl: IntlService) {
            
    console.log('BaseListComponent');
    this.authService.currentUser.subscribe(x => this.currentUser = x);    
    
  }

  protected getDateFormat(date: Date) : string {

    return this.intl.formatDate(date, "yyyy-MM-dd")

  }

  // protected refreshHandler(): void {

  //   this.service.pagination(this.table, this.state);
    
  // }

  protected getInitialState() : State {

    return this.service.getStateEmpty();

  }

  ngOnInit() { 
    
    // this.state = this.getInitialState();
    
    this.view = this.service;
    // this.service.pagination(this.table, this.state)
    
  }

}